/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mac': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M117 94.801h-7.102V55.7c0-3.5-2.898-6.399-6.398-6.399H45.398C41.898 49.301 39 52.2 39 55.7v39.097l-6 .004c-1.602 0-3 1.3-3 3 0 1.602 1.3 3 3 3h84c1.601 0 3-1.3 3-3s-1.301-3-3-3zM74.602 50.602c.898 0 1.602.7 1.602 1.602 0 .898-.7 1.601-1.602 1.601-.898 0-1.602-.699-1.602-1.601 0-.903.7-1.602 1.602-1.602zM80 97H69.102a1.11 1.11 0 0 1-1.101-1.102c0-.601.5-1.101 1.101-1.101L80 94.8c.602 0 1.102.5 1.102 1.101 0 .598-.5 1.098-1.102 1.098zm23.5-5.7H45.7V54.8h57.8v36.5zm12.2 6.7h-2.5c-.2 0-.301-.102-.301-.3 0-.2.101-.302.3-.302h2.5c.2 0 .301.102.301.301 0 .2-.199.301-.3.301z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
